import React from "react";
import Imagen from "../../images/modulo1/pizarra.png";
import LayoutActividad from "../../components/LayoutActividad";

import { modulo1 } from "../../routes/Module1";
import { modulo2 } from "../../routes/Module2";

import Sidebar from "./Sidebar";
import GuiaDocente from "../../components/GuiaDocente";
import AudioPlayer from "../../audioPlayer/AudioPlayer";
import Audio from "../../audios/modulo1/Cierre.mp3";

const Modulo1Conclusion = () => {
  const crumbs = [
    {
      title: modulo1.title,
      url: "/" + modulo1.url,
    },
    {
      title: `Cierre`,
      url: "cierre",
    },
  ];
  const pages = {
    titlePrev: `${modulo1.content[0].name} - ${modulo1.content[0].activities[7].name}`,
    linkPrev: `${modulo1.url}/${modulo1.content[0].path}/${modulo1.content[0].activities[7].path}`,
  };
  const metadata = {
    color: modulo1.color,
    title: `${modulo1.title}`,
    name: modulo1.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h1 className="my-5">Así somos mi familia y yo</h1>
      <AudioPlayer track={Audio} />

      <p>Para terminar, pensemos…</p>
      <ul>
        <li>¿Cuántas familias vemos en esta ilustración?</li>
        <li>¿Quiénes están ayudando a otros dentro de las familias?</li>
        <li>¿Quiénes no están ayudando?</li>
        <li>
          ¿Por qué es importante que todos colaboremos dentro de nuestras
          familias?
        </li>
      </ul>

      <div className="header-img">
        <img src={Imagen} className="card-img-top full-width" alt="..." />
      </div>

      <GuiaDocente>
        <p>
          Lea el título y las preguntas que se plantean. Dialoguen acerca de las
          respuestas. Hay algunas familias donde se ve que todos se esfuerzan en
          ayudar a los demás, y otras en donde eso no ocurre. Finalice
          destacando la importancia de esforzarnos por ayudar para que la
          convivencia en familia sea buena para todos.
        </p>
      </GuiaDocente>

      <div className="unit-options my-5 d-flex flex-column">
        <p>Ir al siguiente módulo:</p>
        <a href={"/" + modulo2.url}>
          <button className={`btn btn-${modulo1.color} me-2`}>
            Mi barrio y yo {">"}
          </button>
        </a>
      </div>
    </LayoutActividad>
  );
};

export default Modulo1Conclusion;
